<template lang="pug">
vs-tooltip(shadow not-hover v-model="isOpen" bottom class="table-custom__options")
  vs-button(icon size="small" transparent  @click="isOpen =! isOpen")
    i.eva.eva-more-horizotnal
  template(#tooltip)
    .content-options
      vs-button(@click="onEditRecord" transparent block animation-type="scale")
        | Editar
        template(#animate)
          i.eva.eva-edit-outline
      vs-button(@click="onDeleteRecord" danger block animation-type="scale")
        | Eliminar
        template(#animate)
          i.eva.eva-trash-2-outline
</template>

<script>
export default {
  name: 'ButtonsMenuTable',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isOpen: false
  }),
  methods: {
    async onEditRecord () {
      await this.toggleTooltip()
      setTimeout(() => this.$emit('onEditRecord', this.data), 200)
    },
    async onDeleteRecord () {
      await this.toggleTooltip()
      setTimeout(() => this.$emit('onDeleteRecord', this.data), 200)
    },
    async toggleTooltip () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
